/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import {
  getallpersondatatypevaluesfromfilter,
  messageMaillingListQuery,
  removemessagelist,
  removepersonmessagelist,
} from "../../../constants/apiParams";
import apiCall, { METHOD } from "../../../constants/baseUrl";
import LoadingPage from "../../CommanComponents/LoadingPage";
import { Translation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import * as actions from "../../../constants/mapDispatchToProps";
import * as stateToProps from "../../../constants/mapStateToProps";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; //Import css
import { getUserID } from "../../../util/utils";

class PersonDataTypeValue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      selectedValue: [],
    };
  }

  componentDidMount() {
    const {list} = this.state
    if(list?.length==0){
      this.loadPersonDataTypeValue();
    }
  }

  loadPersonDataTypeValue = () => {
   
    apiCall(
      METHOD.QUERY,
      getallpersondatatypevaluesfromfilter(
        getUserID(),
        this.props.personDataTypeId,
        this.props.mailIdForPerson
      ),
      (data) => this.handlePersonDataTypeResponse(data),
      (isLoading) => {this.setState({
        isLoading
      })},
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  handlePersonDataTypeResponse = (data) => {
    this.setState({
      list: data.list,
    });
  };

  handleCheckBox = (e, value) => {
    let selectedValue = this.state.selectedValue;
    if (e.target.checked) {
      selectedValue.push(value);
    } else {
      selectedValue = selectedValue.filter((e) => e !== value);
    }
    this.setState({
      selectedValue,
    });
  };

  loader = (<LoadingPage key={0} />);

  render() {
    const { list, selectedValue ,isLoading} = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="wrapper position-relative">
              <div className="header-bg header-yellow sab-header2 sticky-top">
                <div className="container pb-2">
                  <div className="py-2 d-flex align-items-center">
                    <span
                      className="pointer"
                      onClick={() => this.props.handleClosePersonDataValue()}
                    >
                      <i className="zmdi zmdi-arrow-back zmdi-hc-2x"></i>
                    </span>
                    <div className="text-center ">
                    <h5 className="ml-4">
                    {this.props.personDataTypeName}
                    </h5>
                  </div>
                  </div>
                </div>
              </div>
              <div className="middle-section sab-middle-section1">
                <div className="container my-2 00z-index-99">
                  <div className="mt-3">
                  {isLoading && this.loader}
                    {list &&
                      list.map((item, index) => {
                        const { value } = item;
                        return (
                          <>
                            <div
                                    className="icon-box-style3 mb-2 "
                                    key={index}
                                  >
                                    <div className="ml-3  d-flex">
                                      <div className="d-flex w-100">
                                        <div className="0align-self-center">
                                          <label className="checkbox-container">
                                            <input
                                              type="checkbox"
                                              onChange={(e) =>
                                                this.handleCheckBox(e, value)
                                              }
                                              checked={selectedValue.includes(
                                                value
                                              )}
                                            />
                                            <span className="checkmark"></span>
                                          </label>
                                        </div>
                                        <a
                                          href="#"
                                          className="clearfix d-flex align-items-center flex-fill"
                                        >
                                         <div className="align-self-center">
                                      {value == "Yes" ? (
                                        <h5 className=" font-18 d-block">
                                          {t("mailDetailPersonListFilter.yes")}{" "}
                                        </h5>
                                      ) : value == "No" ? (
                                        <h5 className=" font-18 d-block">
                                          {t("mailDetailPersonListFilter.no")}{" "}
                                        </h5>
                                      ) : (
                                        <h5 className=" font-18 d-block">
                                          {value}
                                        </h5>
                                      )}
                                    </div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                              
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="bottom-button">
                  <button type="button" className="btn btn-warning btn-block rounded-0 text-white text-capitalize"
                  onClick={()=>{
                    const {selectedValue} = this.state
                    const value = selectedValue.toString()
                    console.log("value",value);
                    this.props.handleApplyFilter(value)
                  }}
                  >
                     <span><i className="fa fa-chevron-up"> </i></span>
                   {selectedValue.length}  {t("mailDetailPersonListFilter.showContacts")}
                    </button>
              </div>
            </div>
          );
        }}
      </Translation>
    );
  }
}
export default connect(
  (state) =>
    stateToProps.appMapStateToProps(
      [stateToProps.channelDetailStateToProps],
      state
    ),
  actions.appMapDispatchToProps([])
)(withRouter(withTranslation()(PersonDataTypeValue)));
